import { render, staticRenderFns } from "./LabelContent.vue?vue&type=template&id=41175d31&scoped=true&"
import script from "./LabelContent.vue?vue&type=script&lang=js&"
export * from "./LabelContent.vue?vue&type=script&lang=js&"
import style0 from "./LabelContent.vue?vue&type=style&index=0&id=41175d31&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41175d31",
  null
  
)

export default component.exports